import React from 'react'
import { notReadyText } from './connection-field'
import { typeHelp, typeTitle } from './target-words'
import { ArSection, SubHead, TypeLogo } from './workspace-parts'

// A type as a selectable card, built like the API key form's role cards
// (api-key-create-drawer.js ChoiceCard): its icon, its name and one line. A
// type that can't be used yet (ready false: not every service has it) is
// held, with why as its line. A card is a button: picking one moves on to its
// form.
const TypeCard = ({ type, onPick }) => {
  const held = type.ready === false
  const reasonID = `ar-type-${type.type}-why`
  return (
    <button type="button" className="ar-type-card" disabled={held} aria-describedby={reasonID} onClick={() => onPick(type.type)}>
      <TypeLogo type={type.type} />
      <span className="ar-type-card-words">
        <span className="ar-type-card-title">{typeTitle(type)}</span>
        <span className="ar-type-card-help" id={reasonID}>{held ? notReadyText(typeTitle(type)) : typeHelp(type)}</span>
      </span>
    </button>
  )
}

// A new target's first step (owner 2026-10-30: one New target, then "What
// kind of target?"): a card per type in the catalogue, the advanced ones
// (advanced: a Slack webhook link) under their own small heading at the end.
export const TargetTypeStep = ({ types, onPick }) => {
  const main = types.filter(t => !t.advanced)
  const advanced = types.filter(t => t.advanced)
  return (
    <ArSection id="type" title="What kind of target?" lede="Where alerts go. Which alerts go there is up to the routes.">
      <div className="ar-type-cards">{main.map(t => <TypeCard key={t.type} type={t} onPick={onPick} />)}</div>
      {advanced.length > 0 &&
        <div className="mt-4">
          <SubHead title="Advanced" />
          <div className="ar-type-cards mt-2">{advanced.map(t => <TypeCard key={t.type} type={t} onPick={onPick} />)}</div>
        </div>}
    </ArSection>
  )
}
